export const USER_LOCALSTORAGE_KEY = "user";
const SUPPORTED_LANG = ["ru", "en", "cn", "ar", "es", "de"];
